export default class OffersFacets {
  static empty () {
    return new OffersFacets({})
  }

  static from (categories, countries, brands) {
    return new OffersFacets({ categories, countries, brands })
  }

  constructor ({ categories = [], countries = [], brands = [] }) {
    this.categories = categories
    this.countries = countries
    this.brands = brands
  }

  markSelected (filter) {
    const categories = this.categories.map((category) => {
      category.selected = filter.categories.includes(category.code)
      return category
    })

    const countries = this.countries.map((country) => {
      country.selected = filter.countries.includes(country.code)

      if (country.selected) {
        country.cities.map(city => {
          city.selected = filter.cities.includes(city.code)
          return city
        })
      }

      return country
    })

    const brands = this.brands.map((brand) => {
      brand.selected = filter.brands.includes(brand.code)
      return brand
    })

    return this.copy({ categories, countries, brands })
  }

  copy = (partial) => new OffersFacets({
    categories: this.categories,
    countries: this.countries,
    brands: this.brands,
    ...partial
  })
}
